import React from 'react';
import Button from '../../ui/Button';
import { ArrowRight } from 'lucide-react';

const InvoiceActions = ({ handleInvoiceSubmit = (e) => e.preventDefault() }) => {
  return (
    <div className="p-4 sm:p-6 bg-gray-50/50 flex flex-col sm:flex-row items-stretch sm:items-center justify-end rounded-b-2xl gap-3">
      <Button 
        type="submit"
        onClick={handleInvoiceSubmit}
        variant="primary" 
        className="gap-2 px-6 w-full sm:w-auto"
      >
        Преглед и издаване
        <ArrowRight size={16} strokeWidth={2} />
      </Button>
    </div>
  );
};

export default InvoiceActions;
